<template>
  <b-navbar
    sticky
    tag="header"
    toggleable="lg"
    border-variant="dark"
    class="bg-white b-b-1"
  >
    <button
      v-if="hasSidebar && user.id"
      class="navbar-toggler mobile-sidebar-toggler d-lg-none"
      type="button"
      @click="$emit('mobileMenuToggle')"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <b-navbar-brand id="header-logo-big_logo" to="/" aria-label="Home">
      <svg>
        <use xlink:href="#logo"></use>
      </svg>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto align-items-center">
        <b-nav-item
          @click.prevent="clickEvent"
          v-for="{ href, text } in nav"
          :key="href"
          :href="href"
        >
          {{ text }}
        </b-nav-item>

        <b-nav-item to="/cart" v-if="$store.state.user.id">
          <i class="fa fa-shopping-cart"></i>
          <span>
            Cart |
            <span v-if="!totalProducts">
              Empty
            </span>
            <span v-else>
              {{ totalProducts | pluralize("Item") }}
            </span>
          </span>
        </b-nav-item>

        <template v-if="user.id">
          <HeaderDropdownNotif />
          <HeaderDropdownAccnt id="header-logo-small_logo" />
        </template>
        <b-nav-item v-else to="/login">
          Log In
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters } from "vuex";

import HeaderDropdownAccnt from "./HeaderDropdownAccnt.vue";
import HeaderDropdownNotif from "./HeaderDropdownNotif.vue";

export default {
  components: {
    HeaderDropdownAccnt,
    HeaderDropdownNotif
  },

  props: {
    user: Object,
    hasSidebar: Boolean
  },

  data: () => ({
    nav: [
      { text: "Nanome.ai", href: "https://nanome.ai/" },
      { text: "Blog", href: "https://blog.matryx.ai/" }
    ]
  }),

  computed: {
    ...mapGetters("cart", ["totalProducts"])
  },

  methods: {
    clickEvent(e) {
      window.open(e.target.href);
    }
  }
};
</script>

<style lang="scss">
.navbar-brand {
  svg {
    width: 180px;
    height: 30px;
  }
}
</style>
